import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import MetricsByTrimesterRow from './MetricsByTrimesterRow';

const Tbody = ({ metrics }) =>
  metrics.map(metric => <MetricsByTrimesterRow key={metric.id} {...metric} />);

const MetricsByTrimesterTable = ({
  className,
  metrics,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell variant="head" key="id">
          ID
        </TableCell>
        <TableCell variant="head" key="name">
          {t('COMMON.NAME')}
        </TableCell>
        <TableCell variant="head" key="q1" align="center">
          {t('BUSINESS_VIEW.METRICS.Q1')}
        </TableCell>
        <TableCell variant="head" key="q2" align="center">
          {t('BUSINESS_VIEW.METRICS.Q2')}
        </TableCell>
        <TableCell variant="head" key="q3" align="center">
          {t('BUSINESS_VIEW.METRICS.Q3')}
        </TableCell>
        <TableCell variant="head" key="q4" align="center">
          {t('BUSINESS_VIEW.METRICS.Q4')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(() => () => <Tbody metrics={metrics} />, [metrics]);

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) =>
          `${from}-${to} ${t('COMMON.OF')} ${c}`
        }
      />
    ),
    [page, metrics]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

MetricsByTrimesterTable.propTypes = {
  className: PropTypes.string,
  metrics: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  loading: PropTypes.bool
};

MetricsByTrimesterTable.defaultProps = {
  count: 0
};

export default MetricsByTrimesterTable;
